import React from "react";
import { useNavigate } from "react-router-dom";
import formatMoney from "../components/formatMoney";
import "../styles/ordersTable.css";

const OrdersTable = ({ orders, onPayNowClick }) => {
  const navigate = useNavigate();

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  const handleOrderClick = (orderId) => {
    navigate(`/orders/${orderId}`);
  };

  return (
    <div className="orders-table-container">
      <table className="orders-table">
        <thead>
          <tr>
            <th>Order ID</th>
            <th>Date</th>
            <th>Status</th>
            <th>Total Price</th>
            <th>Payment Status</th>
            <th>Products</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {orders.map((order) => (
            <tr
              key={order.order_id}
              onClick={() => handleOrderClick(order.order_id)}
            >
              <td className="order-id">
                {order.order_id.substring(0, 8)}...
              </td>
              <td>
                <span className="order-date">{formatDate(order.created_at)}</span>
              </td>
              <td>
                <span className="order-status">{order.status}</span>
              </td>
              <td>
                <div className="order-price-details">
                  {order.final_total &&
                  order.final_total !== order.total_price ? (
                    <div className="price-with-discount">
                      <span className="original-price">
                        {formatMoney(order.total_price)}
                      </span>
                      <span className="final-price">
                        {formatMoney(order.final_total)}
                      </span>
                    </div>
                  ) : (
                    <span>{formatMoney(order.total_price)}</span>
                  )}
                </div>
              </td>
              <td>
                <span
                  className={`order-payment-status ${
                    order.payment_status === "Paid" ? "paid" : ""
                  }`}
                >
                  {order.payment_status}
                </span>
              </td>
              <td className="products-count">{order.total_products}</td>
              <td className="action-cell">
                <button
                  className={`order-action-btn ${
                    order.payment_status === "Paid" ? "paid" : ""
                  }`}
                  onClick={(event) => onPayNowClick(order, event)}
                >
                  {order.payment_status === "Paid" ? "View Details" : "Pay Now"}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default OrdersTable;
